// src/config/cities.js
// src/config/cities.js
export const CITIES = {
  mumbai: {
    id: 'mumbai',
    name: 'Mumbai',
    center: [19.0760, 72.8777],
    zoom: 13,
    bounds: [
      [18.9, 72.7],
      [19.2, 73.0]
    ]
  },
  pune: {
    id: 'pune',
    name: 'Pune',
    center: [18.5204, 73.8567],
    zoom: 12,
    bounds: [
      [18.3, 73.6],
      [18.8, 74.1]
    ]
  },
  both: {
    id: 'both',
    name: 'Both Cities',
    center: [18.8, 73.3],
    zoom: 11,
    bounds: [
      [18.2, 72.7],
      [19.2, 74.1]
    ]
  }
};

export const DEFAULT_CITY = 'mumbai'; 

export const PROPERTY_TYPES = {
  office: {
    label: 'Office',
    types: ['Office Lease', 'Office Sale']
  },
  warehouse: {
    label: 'Warehouse/Industrial',
    types: ['Warehouse Rent', 'Warehouse Sale', 'Industrial Land', 'Factory', 'Godown', 'Cold Storage', 'Logistics Park']
  }
};
